import { Icon, IconProps } from "../";

export const ReplayIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M52,1195.99344 L52,1194.20344 C52,1193.75344 51.46,1193.53344 51.15,1193.85344 L47.35,1196.64344 C47.15,1196.84344 47.15,1197.15344 47.35,1197.35344 L51.14,1200.14344 C51.46,1200.45344 52,1200.23344 52,1199.78344 L52,1197.99344 C55.73,1197.99344 58.68,1201.41344 57.86,1205.28344 C57.39,1207.55344 55.55,1209.38344 53.29,1209.85344 C49.72,1210.60344 46.54,1208.15344 46.06,1204.84344 C45.99,1204.36344 45.57,1203.99344 45.08,1203.99344 C44.48,1203.99344 44,1204.52344 44.08,1205.12344 C44.7,1209.51344 48.88,1212.76344 53.61,1211.84344 C56.73,1211.23344 59.24,1208.72344 59.85,1205.60344 C60.84,1200.47344 56.94,1195.99344 52,1195.99344 Z"
        transform="translate(-40 -1192)"
      />
    </Icon>
  );
};
